// 存放商品缓存的文件
const productDataCache = new Map();

const actions = {
    set(id, data) {
        // console.log(`设置编号 ${id} 的 product 缓存文件: `, data);
        productDataCache.set(id, data);
    },
    get(id) {
        // console.log(`读取编号 ${id} 的 product 缓存文件`);
        return productDataCache.get(id);
    },
    has(id) {
        return productDataCache.has(id);
    },
    delete(id) {
        // console.log(`删除编号 ${id} 的 product 缓存文件`)
        productDataCache.delete(id);
    },
    clear() {
        // console.log(`清空product的缓存文件`)
        productDataCache.clear();
    },
    size() {
        return productDataCache.size;
    }
};


export default actions;